export default __webpack_public_path__ + "static/media/elk.b6e415f9.svg";